import { render, staticRenderFns } from "./FunnelChartSchool1.vue?vue&type=template&id=1b543f98&scoped=true&"
import script from "./FunnelChartSchool1.vue?vue&type=script&lang=js&"
export * from "./FunnelChartSchool1.vue?vue&type=script&lang=js&"
import style0 from "./FunnelChartSchool1.vue?vue&type=style&index=0&id=1b543f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b543f98",
  null
  
)

export default component.exports